export const preAppConstants = {
	RESET_APPLICATION_STATE: "RESET_APPLICATION_STATE",
};